// extracted by mini-css-extract-plugin
export var container = "layouttrainings-module--container--3ly_n";
export var bar1 = "layouttrainings-module--bar1--1WXag";
export var header = "layouttrainings-module--header--NlSCF";
export var bar2 = "layouttrainings-module--bar2--3KNPe";
export var description = "layouttrainings-module--description--365T1";
export var picture = "layouttrainings-module--picture--H9Djo";
export var places = "layouttrainings-module--places--_cdrW";
export var details = "layouttrainings-module--details--3swUQ";
export var buttonContainer = "layouttrainings-module--buttonContainer--RMx3y";